import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import "./EventDate.scss";
import { Locale } from '../../../../assets/Locale';

export const EventDate = (props)=>{
    const {value, row, isCompact} = props;
    const say = Locale.use();
    
    return (
        <Block className={["EventDate", isCompact ? "compact" : "fullsize"].join(" ")}>
            <div className="date">{say.date(value)}</div>
            <div className="time">{say.time(value)}</div>
        </Block>
    )
}

